import React, { useEffect } from "react";
import { useReactiveVar } from "@apollo/client";
import { activeServiceId, setActiveServiceId } from "../apollo";

interface ServiceSwitcherProps {
  linkServices?: { id: number; name: string }[] | null;
}

// 서비스가 여러 개 배정된 관리자/직원 계정을 위한 "현재 서비스" 전환 UI.
// - 배정된 서비스가 없으면(수퍼관리자) 아무것도 렌더링하지 않는다 (전체 조회).
// - 배정된 서비스가 1개면 전환 없이 현재 서비스명만 보여준다.
// - 배정된 서비스가 여러 개면 드롭다운으로 전환할 수 있다.
export const ServiceSwitcher: React.FC<ServiceSwitcherProps> = ({
  linkServices,
}) => {
  const current = useReactiveVar(activeServiceId);
  const services = linkServices ?? [];

  useEffect(() => {
    if (services.length === 0) {
      if (current !== null) setActiveServiceId(null);
      return;
    }
    const stillAssigned = services.some((service) => service.id === current);
    if (!stillAssigned) {
      setActiveServiceId(services[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [services.map((service) => service.id).join(",")]);

  if (services.length === 0) return null;

  if (services.length === 1) {
    return (
      <div className="mx-4 mb-4 px-3 py-2 rounded bg-white/10 text-white text-xs">
        현재 서비스 <span className="font-bold ml-1">{services[0].name}</span>
      </div>
    );
  }

  return (
    <div className="mx-4 mb-4">
      <label className="block text-white text-xs mb-1">현재 서비스</label>
      <select
        className="w-full rounded px-2 py-1 text-sm text-black"
        value={current ?? ""}
        onChange={(e) => setActiveServiceId(Number(e.target.value))}
      >
        {services.map((service) => (
          <option key={service.id} value={service.id}>
            {service.name}
          </option>
        ))}
      </select>
    </div>
  );
};
